module.exports = __webpack_public_path__ + "static/media/prep-3.77585882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prep-3.jpg
// module id = 165
// module chunks = 0